// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.done[data-v-b20642a0]{ color:gray; text-decoration: line-through;\n}\n.box[data-v-b20642a0] {\r\n            width: 350px;\r\n            display: flex;\r\n            margin-top: 20px;\r\n            align-items: center;\r\n            justify-content: space-between;\n}\n.waveform[data-v-b20642a0] {\r\n            width: 300px;\n}\na[role=btnPause][data-v-b20642a0] {\r\n            display: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
